import { changeLanguage } from "@/i18n/changeLanguage";
import { getDefaultLanguage } from "@/i18n/getDefaultLanguage";

export default function observeHTMLLang() {
    const htmlEl = document.documentElement;

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.type === "attributes" && mutation.attributeName === "lang") {
                const lang = document.documentElement.lang;
                changeLanguage(lang?.split(/[-_]/)?.[0]?.trim());
            }
        }
    });

    observer.observe(htmlEl, { attributes: true });
}